/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Reason for cancellation of previous insurance.   * `CancelledByPolicyholder` - german: gekündigt durch Versicherungsnehmer   * `CancelledByInsurer`      - german: gekündigt durch Versicherungsunternehmen
 */
export const CancellationReason = {
  CancelledByPolicyholder: 'CancelledByPolicyholder',
  CancelledByInsurer: 'CancelledByInsurer',
} as const;
export type CancellationReason = (typeof CancellationReason)[keyof typeof CancellationReason];
